module.exports = __webpack_public_path__ + "img/esus.fdf36a4a.png";